// extracted by mini-css-extract-plugin
export default {"container":"eO-z","topReviewHeading":"fO-z","criticalReview":"gO-z","favorableReview":"hO-z","vsSeparator":"iO-z"};